import React from "react"

import { GatsbySeo } from "gatsby-plugin-next-seo"
import { graphql, useStaticQuery } from "gatsby"
import { getSrc } from "gatsby-plugin-image"

const AcademyPageMetaTagsAndOpenGraphInfo = () => {
  const data = useStaticQuery(graphql`
    {
      siteSettings: markdownRemark(
        frontmatter: { contentKey: { eq: "siteSettings" } }
      ) {
        frontmatter {
          first_name
          last_name
          other_name
          site_absolute_url
          social_media {
            twitter
          }
          site_keywords {
            keyword
          }
        }
      }
      ogImage: markdownRemark(frontmatter: { contentKey: { eq: "homePage" } }) {
        fields {
          slug
        }
        frontmatter {
          hero_section_of_home_page {
            home_page_hero_image {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
      }

      academyPageData: markdownRemark(
        frontmatter: { contentKey: { eq: "academyPage" } }
      ) {
        frontmatter {
          title
          page_description
          our_story {
            featured_image {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
      }
    }
  `)

  const {
    first_name,
    last_name,
    other_name,
    site_absolute_url,

    social_media: { twitter },
  } = data.siteSettings.frontmatter

  const siteKeywords = data.siteSettings.frontmatter.site_keywords
    .map(word => word.keyword)
    .join(", ")

  const name = `${first_name} ${last_name} ${other_name}`

  const OgImage1 = getSrc(
    data.academyPageData.frontmatter.our_story.featured_image
  )

  const OgImage2 = getSrc(
    data.ogImage.frontmatter.hero_section_of_home_page.home_page_hero_image
  )

  const { title, page_description } = data.academyPageData.frontmatter

  return (
    <>
      <GatsbySeo
        title={title}
        description={page_description}
        canonical={`${site_absolute_url}/academy`}
        language="en"
        metaTags={[
          {
            name: "Keywords",
            content: siteKeywords,
          },
          {
            name: "Author",
            content: name,
          },
        ]}
        openGraph={{
          type: "website",
          url: `${site_absolute_url}/academy`,
          title: title,
          description: page_description,
          images: [
            {
              url: OgImage1,
              width: 800,
              height: 600,
              alt: name,
            },
            {
              url: OgImage2,
              width: 900,
              height: 800,
              alt: name,
            },
          ],
          site_name: site_absolute_url,
          profile: {
            firstName: "Muhammad",
            lastName: "Ilyas Kpada",
            gender: "Male",
          },
        }}
        twitter={{
          handle: twitter,
          site: name, // @username for the website used in the card footer.
          cardType: "summary_large_image",
        }}
      />
    </>
  )
}

export default AcademyPageMetaTagsAndOpenGraphInfo
